var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","margin-top":"8px"}},[_c('img',{staticStyle:{"width":"130px"},attrs:{"src":require("../../../assets/images/layout/logo-iph-hori-v1.png"),"alt":"logo-iph"}})])
}]

export { render, staticRenderFns }